module.exports = __webpack_public_path__ + "static/media/insured.0668ed35.svg";